module.exports = "<router-outlet></router-outlet>\n<toaster-container></toaster-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main